import React from 'react';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { IconButton } from '@mui/material';
import { DropzoneRootProps } from 'react-dropzone';

interface UploadButtonProps {
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  iconButtonRender?: React.ReactNode;
  theme: { colors: { tertiary_500: string } };
}

const UploadButton: React.FC<UploadButtonProps> = ({ getRootProps, iconButtonRender, theme }) => (
  <div {...getRootProps()}>
    <IconButton size="small" aria-label="Selecionar imagem">
      {iconButtonRender || (
        <InsertPhotoOutlinedIcon style={{ fontSize: '28px', color: theme.colors.tertiary_500 }} />
      )}
    </IconButton>
  </div>
);

export default UploadButton;
